import { render } from "./MainFooter.vue?vue&type=template&id=7445377f"
import script from "./MainFooter.vue?vue&type=script&lang=js"
export * from "./MainFooter.vue?vue&type=script&lang=js"
script.render = render

export default script